import React, { useState, useEffect } from "react";
import PAmodal from "../PApop";

import styled, { css } from "styled-components";
import { PAcardInfo } from "../cards/PAcardInfo";
import { PAxcomOneCard } from "./PAxcomOneCard";

export const PAxcomCards = ({
  solutions = [],
  // appear = false,
  shown = true,
  size = "md",
  uiState = { all: true },
  limit,
  filter,
  hardlimit,
  platforms = [],
  cards
}) => {
  const [popState, setPopState] = useState(false);
  const [on, setOn] = useState([]);
  useEffect(() => {
    console.log("on = ", on);
  }, [on]);
  const appear = index => {
    let d = setTimeout(() => {
      // debugger;
      if (on.indexOf(`one_solution_${index}`) === -1)
        setOn([...on, `one_solution_${index}`]);
    }, index * 300);
  };

  const filterCards = (filt, cards) => {
    if (cards.length && !cards[0]["tag"]) {
      return cards;
    }
    // debugger
    return cards.filter(
      (oneCard, ind) =>
        !filt ||
        filt === "all" ||
        (oneCard["tag"] && oneCard["tag"].indexOf(filt) !== -1)
    );
  };

  const checkIfShow = card => {
    let ret = false;

    if (!filter || filter === "all") {
      ret = true;
    }

    // filter.forEach((f, ind) => {
    //   ret = card['tag'].indexOf(f) !== -1 ? true : false;
    //   ret = card['platform'].indexOf(f) !== -1 ? true : false;
    // })
    // debugger
    ret = card["tag"].indexOf(filter) !== -1 ? true : ret;

    let platfShow = false;
    card["platform"].forEach(oneF => {
      platfShow =
        platforms.indexOf(oneF) !== -1 && platforms.indexOf(oneF) !== -1
          ? true
          : platfShow;
    });

    let needShow = false;
    card["monetization"].forEach(oneF => {
      needShow =
        platforms.indexOf(oneF) !== -1 && platforms.indexOf(oneF) !== -1
          ? true
          : needShow;
    });

    return platfShow && needShow ? ret : false;
  };

  // const checkIfFilt = (filtId) => {
  //   return filt.indexOf(filtId) !== -1 ? filt.indexOf(filtId) : false
  // }

  return (
    <div
      className={`p_x_sol-grid ${uiState["all"] ? `p_x_sol-grid--x` : ``}`}
      style={{
        // maxHeight: size === 'md' ? "510px" : 'none',
        width: "calc(100% + 32px)",
        marginLeft: "-16px",
        marginRight: "-16px",
        // display: 'grid',
        // gridTemplateColumns: `repeat(${solutions.length}, minmax(360px, 1fr))` ,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        height: hardlimit ? 510 : "auto",
        overflow: hardlimit ? "hidden" : "auto"
      }}
      // className="p_x_sol-grid p_x_sol-grid--x"
    >
      {popState !== false && (
        <PAmodal
          size="lg"
          appearance="flatten"
          handleClose={() => {
            setPopState(false);
          }}
          handleModal={() => {
            setPopState(false);
          }}
        >
          <PAcardInfo card={solutions[popState]} />
        </PAmodal>
      )}

      {solutions.map((oneSol, index) => {
        if (!limit || (limit && index < limit))
          // appear(index)
          return (
            <CssAppearer
              shown={checkIfShow(oneSol)}
              on={on.indexOf(`one_solution_${index}`) > -1 ? true : false}
              appear={250}
              size={size}
              index={index}
              key={`one_solution_${index}`}
              className={`p_x_sol_item ${
                uiState["all"] ? `p_x_sol_item--x` : ``
              }`}
              style={{
                zIndex: 1
              }}
            >
              {on.indexOf(`one_solution_${index}`) > -1}
              <PAxcomOneCard
                inProgress={index === 0 ? true : false}
                index={index}
                handlePop={setPopState}
                size={size}
                {...oneSol}
              />
            </CssAppearer>
          );
      })}
    </div>
  );
};

export const CssAppearer = ({
  on = false,
  style,
  index,
  children,
  shown = true,
  size
}) => {
  // const [isOn, setOn] = useState(on);
  // useEffect(() => {
  //   setTimeout(() => {
  //     setOn(true)
  //   }, (index+1)*10 );
  // }, [])

  return (
    <CssAppearerEl0
      shown={shown}
      style={
        {
          // maxWidth: shown ? 320 : 0,
          // margin: shown ? "0px 16px 32px 16px" : 0,
          // maxHeight: size === "md" ? 480 : 380,
          // minHeight: size === "md" ? 480 : 380,
          // transition: 'all 300ms ease-in-out',
          // // overflow: 'hidden',
          // display: "flex",
          // flexDirection: "column",
          // justifyContent: "stretch",
        }
      }
    >
      <CssAppearerEl style={style} appear={on} shown={true}>
        {children}
      </CssAppearerEl>
    </CssAppearerEl0>
  );
};

const CssAppearerEl0 = styled.div`
  /* width: 364px; */
  width: 33.33333333%;
  /* height: 480px; */
  /* margin: 0 4px 8px 4px; */
  transition: all 300ms ease-in-out;
  opacity: 1;
  ${({ appear }) =>
    !appear &&
    css`
      /* transform: translate(0, 20px); */
    `};

  ${({ shown }) =>
    !shown &&
    css`
      transform: scale(0.9);
      opacity: 0;
      width: 0px;
      margin: 0;
      padding: 0;
      overflow: hidden;
    `}

  @media(max-width: 768px) {
    margin: 0;
    width: 100%;
    height: 290px;
    ${({ shown }) =>
      !shown &&
      css`
        width: 0px;
        height: 0px;
        /* transform: scale(0.9); */
        opacity: 0;
        width: 0px;
        margin: 0;
        padding: 0;
        overflow: hidden;
      `}
  }
`;

const CssAppearerEl = styled.div`
  /* width: 360px; */
  display: flex;
  /* height: 500px; */
  margin: 0 16px 24px 16px;
  transition: all 300ms ease-in-out;
  opacity: 1;
  ${({ appear }) =>
    !appear &&
    css`
      /* transform: translate(0, 20px); */
    `};

  /* @media(max-width: 768px) {
    margin-left: -70px;
    margin-top: -110px;
    padding: 24px;
    transform: scale(0.6);
  } */
`;
